<template>
  <div class="row" v-if="!isSubParam && dataReady">
    <div class="col">
      <span><b>{{ title }}</b></span>
      <Popper arrow class="light" :content="popover"
        :key="triggerParamPopover">
        <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
    </div>
  </div>

  <div class="row" v-if="dataReady">
    <div class="col" v-if="isSubParam">
      <span>{{ title }}</span>
      <Popper arrow class="light" :content="popover">
        <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
    </div>
    <div class="col">
      <div class="form-group" :id="title">
        <base-input v-if="type === 'number'" formClasses="input-group-alternative" type="number" placeholder="0.000"
          step="0.001" min="0.000" :value="model" v-on:change="updateValue($event.target.value)" :key="model">
        </base-input>
        <base-switch v-if="type === 'switch'" :value="Boolean(model)" @input="updateValue(Boolean($event))">
        </base-switch>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ParamInput",
  props: {
    title: {
      type: String,
      default: "none",
      description: "Parameter title",
    },
    isSubParam: {
      type: Boolean,
      default: false,
      description: "whether is a sub parameter or not",
    },
    popover: {
      type: String,
      default: "",
      description: "Popover description",
    },
    modelValue: {
      type: Object,
      default: null,
      description: "Model object to be filled",
    },
    type: {
      type: String,
      default: "number",
      description: "Input type (number|switch)",
    },
  },
  data() {
    return {
      model: null,
      dataReady: false,
    };
  },
  mounted() {
    this.model = this.modelValue
    this.dataReady = true
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value)
    }
  },
};
</script>
<style></style>
